/** The NMLS Mortgage Call Report configuration, as the admin endpoint serves it. */
export interface IMcrConfig {
  companyNmlsId: string
  legalName: string
  filerType: 'standard' | 'expanded'
  fiscalYearEnd: string
  states: string[]
  statusDispositions: Record<string, string>
  accountLines: Record<string, string>
  xmlFieldMap: Record<string, string>
  residentialOnly: boolean
  foreclosureTags: string[]
  bankruptcyTags: string[]
  foreclosureServicingStatuses: string[]
  bankruptcyServicingStatuses: string[]
}

export interface IMcrAccount {
  no: number
  number: string
  name: string
  type: string
  /** What the tenant pinned this account to, blank when they have not. */
  configuredLine: string
  /** What the report would classify it as on its own — shown so a blank row is not a blank answer. */
  inferredLine: string
}

export interface IMcrXmlField {
  name: string
  section: string
  type: string
  label: string
}

export interface IMcrAdminView {
  config: IMcrConfig
  /** What is still missing before the filing is complete. */
  missing: string[]
  dispositionOptions: Record<string, string>
  fcLineOptions: Record<string, string>
  loanStatusLabels: Record<string, string>
  servicingStatusLabels: Record<string, string>
  /** Loan status -> HMDA action-taken code, the fallback when no MCR disposition is set. */
  hmdaActionTaken: Record<string, string>
  /** What each status resolves to today, explicit mapping and fallbacks folded in. */
  effectiveDispositions: Record<string, string>
  accounts: IMcrAccount[]
  xmlFields: IMcrXmlField[]
}

export const defaultMcrConfig = (): IMcrConfig => ({
  companyNmlsId: '',
  legalName: '',
  filerType: 'standard',
  fiscalYearEnd: '12-31',
  states: [],
  statusDispositions: {},
  accountLines: {},
  xmlFieldMap: {},
  residentialOnly: true,
  foreclosureTags: [],
  bankruptcyTags: [],
  foreclosureServicingStatuses: [],
  bankruptcyServicingStatuses: [],
})
